export default __webpack_public_path__ + "static/referrer-light-fdb5744694c8d5236c001acb1741220e.png";